import { QSetReviewMainTaskQSetProvider } from '@exam-management/qset-review-view-question';
import { useParams } from '@exam-management/router';
import { Outlet } from 'react-router-dom';
export default function ExamDetailsLayout() {
  const { taskId, qSetId } = useParams(
    '/task-management/qset-review/:taskId/qset/:qSetId/review-result/exam-details',
  );
  return (
    <>
      <QSetReviewMainTaskQSetProvider mainTaskId={taskId} qSetId={qSetId}>
        <Outlet />
      </QSetReviewMainTaskQSetProvider>
    </>
  );
}
